import { Outlet } from 'react-router-dom';
import Gnb from '@/components/organisms/Gnb';
import Footer from '@/components/organisms/Footer';
import { useRecoilState } from 'recoil';
import { useEffect } from 'react';
import { isMobileState } from '@/store/atom';

type RootlayoutProps = {
  isViewFooter?: boolean;
  bgColor?: string;
};

const FlexRootlayout = ({ bgColor = 'bg-gr-50', isViewFooter }: RootlayoutProps) => {
  const [, setIsMobile] = useRecoilState(isMobileState);

  // 모바일 환경 감지
  useEffect(() => {
    setIsMobile(/Mobi|Android/i.test(navigator.userAgent));
  }, [setIsMobile]);

  return (
    <div className={`flex  h-[100svh] flex-col ${bgColor}`}>
      <div className="hidden lg:block">
        <Gnb />
      </div>

      <main className="flex h-full w-full flex-1 ">
        <Outlet />
      </main>

      {isViewFooter && <Footer />}
    </div>
  );
};

export default FlexRootlayout;
